<p-dialog [(visible)]="visible" modal="true" header="Low Wallet Balance" [closable]="true"  [style]="{ width: '600px' }">
  <p>Your wallet balance is ₹{{ availableBalance }}.</p>
  <p *ngIf="availableBalance <= 0">Please recharge your wallet to continue using services.</p>

  <div class="flex justify-content-end mt-3">
    <button pButton type="button" label="Recharge" class="btn-primary mr-2" (click)="goToWallet()"></button>
    <button pButton type="button" label="Dismiss" (click)="dismiss()" class="cancel-button"></button>
  </div>
</p-dialog>